import { useMemo } from 'react';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';

import { useTable } from 'react-table';
import { WeightBreakdownWrapper } from './styles';
import pick from 'lodash/pick';

const tableHeaders = [
  {
    Header: `Weight per Discipline (tons)`,
    columns: [
      {
        Header: 'Structure',
        accessor: 'weightStructure',
      },
      {
        Header: 'Mechanical',
        accessor: 'weightMechanical',
      },
      {
        Header: 'Piping',
        accessor: 'weightPiping',
      },
      {
        Header: 'Electrical',
        accessor: 'weightElectrical',
      },
      {
        Header: 'Instrument',
        accessor: 'weightInstrument',
      },
    ],
  },
  {
    Header: `Total weight (tons)`,
    columns: [
      {
        Header: 'Dry',
        accessor: 'totalWeightDry',
      },
      {
        Header: 'Fluids',
        accessor: 'totalWeightFluids',
      },
      {
        Header: 'Operating',
        accessor: 'totalWeightOperating',
      },
    ],
  },
];

const WeightBreakdown = ({ printMode, idCardData }) => {
  const columns = useMemo(() => tableHeaders, []);

  let tableData = [
    pick(idCardData, [
      'weightStructure',
      'weightMechanical',
      'weightPiping',
      'weightElectrical',
      'weightInstrument',
      'totalWeightDry',
      'totalWeightFluids',
      'totalWeightOperating',
    ]),
  ];

  const Table = ({ columns, data }) => {
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
      columns,
      data,
    });

    return (
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render('Header')}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell) => (
                  <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  return (
    <WeightBreakdownWrapper printMode={printMode}>
      <Table
        columns={columns}
        data={tableData}
      />
    </WeightBreakdownWrapper>
  );
};

export default WeightBreakdown;
